import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ToastComponent } from '../../../components/toast/toast.component';
import { EcontentServicesService } from '../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { Observable, Subscription } from 'rxjs';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';
import { Router } from '@angular/router';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-econtent-student',
  imports: [ 
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        CommonModule,
        MatMenuModule,
        MatFormFieldModule,
        MatCardModule,
        DynamicFormQuestionComponent,
        ReactiveFormsModule,
        PaginationComponent,
        TranslateDirective
      ],
  templateUrl: './econtent-student.component.html',
  styleUrl: './econtent-student.component.scss',
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers:[QuestionControlService]
})
export class EcontentStudentComponent implements OnInit{

displayedColumns: string[] = ['slno','subjects', 'subject_id', 'actions'];
dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
questions: Inputfiledsbase<string>[] | null = [];
questions$: Observable<Inputfiledsbase<any>[]> | null;
form!: FormGroup;
private subscription: Subscription | undefined;
studentEcontentData:any;
total_count: number = 0;
user : any;
course = "";
semesterId : number = 0;
paginationData: any;

constructor(
  private router: Router,
  private eContentFormQuestions: EcontentServicesService,
  private qcs: QuestionControlService,
  private apiservices: ApiservicesService,
  public connectiveServices : ConnectiveservicesService
){
  this.questions$ = this.eContentFormQuestions.getstudentsemesterform();
    this.questions$.subscribe((questions) => {
      this.questions = questions;
      this.form = this.qcs.toFormGroup(
        this.questions as Inputfiledsbase<string>[]
      );
    });
  this.user = this.connectiveServices.getuserdata()?.data;
  this.course = this.user?.course_name;
}

ngOnInit(): void {
  this.subscription = this.eContentFormQuestions.notifyStdEcontentSubject$.subscribe(() => {
      this.getEcontentdata();
    });
}

getEcontentdata(){
  this.semesterId = this.form.getRawValue()?.semester;
  console.log("Student Semester id:",this.semesterId);
  this.apiservices.getEcontentStdSubList(this.user.id,this.user.course_id,this.semesterId,this.paginationData).subscribe((res) => {
      this.studentEcontentData = res?.subjects;
      this.total_count = res?.subject_count;
      this.dataSource = new MatTableDataSource<any>(res?.subjects);
    });
}

viewESubjectData(subjectId: number,subjectname:any) {
    this.router.navigate([
      `e-content/${this.user?.course_id}/${this.semesterId}/${subjectId}/${subjectname}/econtent-subjects-data`,
    ]);
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getEcontentdata();
  }

ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();  // Clean up the subscription
    }
  }

}
